import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { useRouter } from "@tanstack/react-router";
import { Row } from "@tanstack/react-table";
import { IconTrash, IconEye } from "@tabler/icons-react";
import { Organization } from "@/features-root-user/service/organization";
import { useAtom } from "jotai";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  organizationsDialogAtom,
  organizationsCurrentRowAtom,
} from "../store/organizations-atom";

interface DataTableRowActionsProps {
  row: Row<Organization>;
}

export function DataTableRowActions({
  row,
}: Readonly<DataTableRowActionsProps>) {
  const router = useRouter();
  const [, setOpen] = useAtom(organizationsDialogAtom);
  const [, setCurrentRow] = useAtom(organizationsCurrentRowAtom);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="data-[state=open]:bg-muted flex h-8 w-8 p-0"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem
          onClick={() => {
            void router.navigate({
              to: "/root-user/organization/organization/$id/detail",
              params: { id: row.original.id },
            });
          }}
        >
          View
          <DropdownMenuShortcut>
            <IconEye size={16} />
          </DropdownMenuShortcut>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="w-full">
                <DropdownMenuItem
                  onClick={() => {
                    setCurrentRow(row.original);
                    setOpen("delete");
                  }}
                  className="!text-red-500"
                  disabled={true}
                >
                  Delete
                  <DropdownMenuShortcut>
                    <IconTrash size={16} />
                  </DropdownMenuShortcut>
                </DropdownMenuItem>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>Delete is not available at the moment</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
